import { BusMessage, MessageFactory, UID_BYTES_PER_ELEMENT } from "flavr-common";
export const ROOM_TRANSITION_FADE_DURATION_MS = 500;
/** Starts only the visual fade, before room-transition work is allowed to run. */
export class StartRoomTransitionFadeMessage extends BusMessage {
    get byteLength() {
        return UID_BYTES_PER_ELEMENT;
    }
    constructor(uid) {
        super();
        this.uid = uid;
    }
    serialization(stream) {
        this.uid = stream.uid(this.uid);
    }
    static is(msg) {
        return msg.type === StartRoomTransitionFadeMessage.typestatic;
    }
}
StartRoomTransitionFadeMessage.typestatic = "StartRoomTransitionFadeMessage";
StartRoomTransitionFadeMessage.subjectstatic = "room";
MessageFactory.register(StartRoomTransitionFadeMessage);
